/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/sort-comp */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import {useState, useEffect, useRef} from 'react';
import Locale from '../util/Locale';
import RenameFolder from '../components/RenameFolder';
import DeleteFolder from '../components/DeleteFolder';
import AddFolder from '../components/AddFolder';
import MoveFolder from '../components/MoveFolder';
import MoveAsset from '../components/MoveAsset';
import Util from '../util/Util';
import Analytics from '../util/Analytics';
import './FolderView.scss';

const MEATBALL_ICON_BASE64 = btoa(
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#00528A" d="M12 9.984q0.797 0 1.406 0.609t0.609 1.406-0.609 1.406-1.406 0.609-1.406-0.609-0.609-1.406 0.609-1.406 1.406-0.609zM18 9.984q0.797 0 1.406 0.609t0.609 1.406-0.609 1.406-1.406 0.609-1.406-0.609-0.609-1.406 0.609-1.406 1.406-0.609zM6 9.984q0.797 0 1.406 0.609t0.609 1.406-0.609 1.406-1.406 0.609-1.406-0.609-0.609-1.406 0.609-1.406 1.406-0.609z"></path></svg>'
);
const ADD_ICON_BASE64 = btoa(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><g><path fill="#00528A" d="M1,12,23,12" stroke-width="2" stroke="#00528A"/><path fill="#00528A" d="M12,1,12,23" stroke-width="2" stroke="#00528A"/></g></svg>'
);
const MOVE_ICON_BASE64 = btoa(
    '<svg fill="none" height="24" stroke="#00528A" strokeLinecap="round" strokeLinejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><polyline points="5 9 2 12 5 15"/><polyline points="9 5 12 2 15 5"/><polyline points="15 19 12 22 9 19"/><polyline points="19 9 22 12 19 15"/><line x1="2" x2="22" y1="12" y2="12"/><line x1="12" x2="12" y1="2" y2="22"/></svg>'
);
const CLOSE_ICON_BASE64 = btoa(
    '<svg fill="none" height="24" stroke="#00528A" strokeLinecap="round" strokeLinejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><line x1="18" x2="6" y1="6" y2="18"/><line x1="6" x2="18" y1="6" y2="18"/></svg>'
);

const MEDIA_TYPE = {
    ASSET: 'asset',
    FOLDER: 'folder'
};

function FolderView(props) {
    const [isError, setIsError] = useState(false);
    const [hintMessage, setHintMessage] = useState(Locale.getText('SELECT_DESTINATION_FOLDER'));
    const [scrollDone, setScrollDone] = useState(false);
    const treeRef = [useRef(), useRef()];

    const scrollToOpenFolder = () => {
        const currentPaths = props.selectedNode;
        if (currentPaths && currentPaths.length > 0) {
            if (treeRef[0] && treeRef[0].current) {
                const scrollToPath = currentPaths[currentPaths.length - 1];
                let treeNode = treeRef[0].current.shadowRoot.querySelector(`[path="${scrollToPath}"]`);
                if (treeNode && treeNode.scrollIntoView) {
                    treeNode.scrollIntoView();
                } else if (treeRef[1] && treeRef[1].current) {
                    treeNode = treeRef[1].current.shadowRoot.querySelector(`[path="${scrollToPath}"]`);
                    if (treeNode && treeNode.scrollIntoView) {
                        treeNode.scrollIntoView();
                    }
                }
            }
        }
    };

    useEffect(() => {
        if (!scrollDone && props.selectedNode) {
            setScrollDone(true);
            setTimeout(scrollToOpenFolder, 0); // Wait an iteration for dom to be set
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.selectedNode]);

    const swapPathsWithLabels = path => {
        if (props.data) {
            const pathList = Util.rootedArrayPath(path);
            const newPathList = [];
            for (let i = 1; i < pathList.length; i += 1) {
                const node = Util.findNode(pathList.slice(0, i + 1), props.data);
                if (node && node.label) {
                    newPathList.push(node.label);
                }
            }
            return newPathList.join(' > ');
        }
        return path;
    };

    const isValidMoveDestination = destPath_ => {
        const isAssetMove = Util.determineMovementType(props.movementSrc) === MEDIA_TYPE.ASSET;
        if (isAssetMove) {
            const destFolder = destPath_[destPath_.length - 2];
            const srcFolder = Util.findNode(Util.rootedArrayPath(props.location), props.data);
            const destPath = destPath_.slice(0, -1);
            if (
                destFolder === srcFolder.path ||
                (props.controllerApi &&
                    (props.controllerApi.isAdvertisingRoot() ||
                        props.controllerApi.isAdvertisingRoot(Util.rootedArrayPath(destPath).join('>'))))
            ) {
                return false;
            }
        }

        if (Util.determineMovementType(props.movementSrc) === MEDIA_TYPE.FOLDER) {
            const destPath = destPath_.slice(0, -1);
            const srcPath = JSON.parse(JSON.stringify(props.movementSrc));
            srcPath.shift();
            if (
                destPath.length > 1 &&
                destPath[0] === srcPath[0] &&
                destPath[destPath.length - 1] !== srcPath[srcPath.length - 1]
            ) {
                const node = Util.findNode(Util.rootedArrayPath(destPath), props.data);
                if (node && !node.locked) {
                    const dpath = destPath.join('>');
                    const spath = srcPath.join('>');
                    const isDropNodeChildOfDragNode = dpath.indexOf(`${spath}>`);
                    const isParent =
                        srcPath.length === destPath.length + 1 &&
                        srcPath[destPath.length - 1] === destPath[destPath.length - 1];
                    if (isDropNodeChildOfDragNode !== 0 && !isParent) {
                        return true;
                    }
                }
            }
            return false;
        }
        const destPath = destPath_.slice(0, destPath_.length - 1);
        if (destPath.length > 1 || (destPath.length && isAssetMove)) {
            const node = Util.findNode(Util.rootedArrayPath(destPath), props.data);
            if (node && !node.locked) {
                return true;
            }
        }
        return false;
    };

    const onItemClicked = event => {
        const {value} = event.target;
        if (typeof value === 'string') {
            const action = Util.rootedArrayPath(value);
            const actionType = action[action.length - 1];

            if (actionType === 'label') {
                if (!props.movementSrc) {
                    props.toggleSidebar();
                }
            } else if (actionType === 'edit') {
                if (props.setShowModal) {
                    const parentPath = action.slice(0, -1);
                    const node = Util.findNode(parentPath, props.data);
                    if (node && node.label) {
                        Analytics.trackEvent('Folder', 'Edit (Modal)');
                        props.setShowModal({
                            content: (
                                <RenameFolder
                                    title={Locale.getText('RENAME_FOLDER')}
                                    name={node.label}
                                    setShowModal={props.setShowModal}
                                    onAction={props.onRenameSelectedFolder}
                                />
                            )
                        });
                    }
                }
            } else if (actionType === 'trash') {
                const parentPath = action.length > 2 ? action.slice(0, action.length - 2) : [];
                Analytics.trackEvent('Folder', 'Delete (Modal)');

                const parentNode = Util.findNode(parentPath, props.data);
                props.setShowModal({
                    content: (
                        <DeleteFolder
                            title={Locale.getText('DELETE_FOLDER')}
                            parent={parentNode ? parentNode.label : ''}
                            setShowModal={props.setShowModal}
                            onAction={props.onDeleteSelectedFolder}
                        />
                    ),
                    width: 60,
                    maxWidth: 600
                });
            } else if (actionType === 'icon-1') {
                Analytics.trackEvent('Folder', 'Add (Modal)');
                props.setShowModal({
                    content: (
                        <AddFolder
                            title={Locale.getText('ADD_NEW_FOLDER')}
                            setShowModal={props.setShowModal}
                            onAction={props.onCreateFolder}
                        />
                    )
                });
            } else if (actionType === 'icon-3' || actionType === 'disclosure') {
                setIsError(false);
                setHintMessage(Locale.getText('SELECT_DESTINATION_FOLDER'));
                props.onFolderAction(event);
                return;
            }
        }

        if ('onFolderAction' in props) {
            if (value.drop && value.on) {
                if (event.persist) {
                    event.persist();
                }

                const srcFolder = swapPathsWithLabels(value.drop);
                const dstFolder = swapPathsWithLabels(value.on);
                props.setShowModal({
                    content: (
                        <MoveFolder
                            title={Locale.getText('MOVE_FOLDER')}
                            srcFolder={srcFolder}
                            dstFolder={dstFolder}
                            setShowModal={props.setShowModal}
                            onAction={async () => props.onFolderAction(event)}
                        />
                    )
                });
            } else if (props.movementSrc) {
                if (event.persist) {
                    event.persist();
                }

                const newSrcPath = JSON.parse(JSON.stringify(props.movementSrc));
                const newDstPath = JSON.parse(JSON.stringify(event.target.value.split('>')));
                const dest = isValidMoveDestination(newDstPath);

                newDstPath.pop();
                newSrcPath.shift();
                const srcFolder = swapPathsWithLabels(newSrcPath.join('>'));
                const dstFolder = swapPathsWithLabels(newDstPath.join('>'));

                if (dest) {
                    if (Util.determineMovementType(props.movementSrc) === MEDIA_TYPE.ASSET) {
                        const parentNode = Util.findNode(Util.rootedArrayPath(newDstPath), props.data);
                        props.setShowModal({
                            content: (
                                <MoveAsset
                                    title={Locale.getText('MOVE_ASSET')}
                                    assetList={props.movementSrc}
                                    dstFolder={dstFolder}
                                    setShowModal={() => {
                                        props.setMovementSrc(null);
                                        props.setShowModal();
                                    }}
                                    onAction={async () => {
                                        const status = await props.onMoveAssetList(props.movementSrc, parentNode.path);
                                        props.setMovementSrc(null);
                                        return status;
                                    }}
                                />
                            )
                        });
                    } else {
                        setIsError(false);
                        setHintMessage(Locale.getText('SELECT_DESTINATION_FOLDER'));
                        props.setShowModal({
                            content: (
                                <MoveFolder
                                    title={Locale.getText('MOVE_FOLDER')}
                                    srcFolder={srcFolder}
                                    dstFolder={dstFolder}
                                    setShowModal={props.setShowModal}
                                    onAction={async () => props.onFolderAction(event)}
                                />
                            )
                        });
                    }
                } else if (!props.isDraggingAsset) {
                    setIsError(true);
                    setHintMessage(Locale.getText('SELECT_VALID_FOLDER'));
                } else {
                    props.setMovementSrc(null);
                }
                props.setDraggingAsset(false);
            } else {
                props.onFolderAction(event);
            }
        }
    };

    const renderTree = () => {
        if ('data' in props && props.data) {
            return (
                <div className="folderview-filetree">
                    {props.data.children.map((data, idx) => {
                        const allowExternalTree = props.allowExternalWebElements && data.root === 'default';
                        return (
                            <div
                                key={`tree-${data.root}-${idx}`}
                                className={`section-${data.root} ${props.movementSrc ? 'is-moving' : ''}`}
                            >
                                {data.sectionTitle && (
                                    <div className="section-divider">
                                        <span className="section-border" />
                                        <span className="section-title">{data.sectionTitle}</span>
                                    </div>
                                )}
                                <nsemble-tree
                                    {...((!props.movementSrc || props.isDraggingAsset) && {dragndrop: true})}
                                    loadingtext={Locale.getText('LOADING_')}
                                    ref={treeRef[idx]}
                                    onInput={onItemClicked}
                                    nodes={JSON.stringify(data)}
                                    {...(allowExternalTree && {allowexternal: true})}
                                    icons={JSON.stringify([
                                        `data:image/svg+xml;base64,${MEATBALL_ICON_BASE64}`,
                                        {
                                            icon: `data:image/svg+xml;base64,${ADD_ICON_BASE64}`,
                                            alt: Locale.getText('ADD_FOLDER')
                                        },
                                        {
                                            icon: `data:image/svg+xml;base64,${MOVE_ICON_BASE64}`,
                                            alt: Locale.getText('MOVE_FOLDER')
                                        },
                                        {
                                            icon: `data:image/svg+xml;base64,${CLOSE_ICON_BASE64}`,
                                            alt: Locale.getText('CLOSE')
                                        },
                                        {
                                            icon: 'edit',
                                            alt: Locale.getText('RENAME_FOLDER')
                                        },
                                        {
                                            icon: 'trash',
                                            alt: Locale.getText('DELETE')
                                        }
                                    ])}
                                />
                            </div>
                        );
                    })}
                </div>
            );
        }
        return null;
    };

    const shouldShowAddFolder = () => {
        if (props.controllerApi && props.controllerApi.selectedNode) {
            const pathParm = props.controllerApi.selectedNode.split('>');
            const path = pathParm.length && pathParm[0] === Util.ROOT_DIR ? pathParm : Util.rootedArrayPath(pathParm);
            const node = Util.findNode(path, JSON.parse(JSON.stringify(props.data)));
            return !(node && node.preventSubfolder);
        }
        return true;
    };

    const renderAddFolderButton = () => {
        return (
            <nsemble-button
                className="add-folder-button"
                text
                title={Locale.getText('ADD_FOLDER')}
                onClick={() => {
                    props.setShowModal({
                        content: (
                            <AddFolder
                                title={Locale.getText('ADD_NEW_FOLDER')}
                                setShowModal={props.setShowModal}
                                onAction={props.onCreateFolder}
                            />
                        )
                    });
                }}
            >
                {Util.getAddIcon()}
            </nsemble-button>
        );
    };

    const renderNetworkError = () => {
        return (
            <div className="folder-network-error">
                <div className="network-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="48px" height="48px">
                        <path d="M0 0h24v24H0V0z" fill="none" />
                        <path d="M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3c-.55 0-1 .45-1 1v4.7c0 .2.06.39.17.55L8 19v2c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2l2.83-5.75c.11-.16.17-.36.17-.55V8c0-.55-.45-1-1-1zm-2 0h-2V5.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5V7h-2V5.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5V7H8V4h8v3z" />
                    </svg>
                </div>
                <span>{Locale.getText('NETWORK_ERROR')}</span>
            </div>
        );
    };

    const renderMovementHelp = () => {
        return (
            <div className={`folderview-hints ${isError && 'folderview-error'}`}>
                <span>{hintMessage}</span>
                <nsemble-button
                    destructive-text
                    onClick={() => {
                        if (Util.determineMovementType(props.movementSrc) === MEDIA_TYPE.FOLDER) {
                            Analytics.trackEvent('Folder', 'Move (Cancel)');
                        } else {
                            Analytics.trackEvent(props.movementSrc.length > 1 ? 'Assets(s)' : 'Asset', 'Move (Cancel)');
                        }

                        if (props.setMovementSrc) {
                            props.setMovementSrc(null);
                        }

                        if (props.toggleSidebar) {
                            props.toggleSidebar();
                        }
                    }}
                >
                    {Locale.getText('CANCEL')}
                </nsemble-button>
            </div>
        );
    };

    return (
        <div className="folderview">
            <div className="folderview-header">
                <div className="folderview-title">{Locale.getText('MEDIA_LIBRARY')}</div>
                {!props.movementSrc && shouldShowAddFolder() && renderAddFolderButton()}
            </div>
            {renderTree()}
            {props.movementSrc && !props.isDraggingAsset && !props.getShowModal() && renderMovementHelp()}
            {props.networkTimeout &&
                'context' in props.networkTimeout &&
                props.networkTimeout.context === 'folders' &&
                renderNetworkError()}
        </div>
    );
}

export default FolderView;
